export class SkeletonService {
  private selectors: string[];

  constructor() {
    this.selectors = ['.skeleton', '.skeleton-text', '.skeleton-avatar'];
  }

  public toggle(container: HTMLElement | Document = document, state?: boolean): void {
    const skeletons = container.querySelectorAll(this.selectors.join(','));
    skeletons.forEach(el => {
      const element = el as HTMLElement;
      if (state !== undefined) {
        element.classList.toggle('loading', state);
      } else {
        element.classList.toggle('loading');
      }
    });
  }

  public start(container: HTMLElement | Document): void {
    this.toggle(container, true);
  }

  public stop(container: HTMLElement | Document): void {
    this.toggle(container, false);
  }
}
